import { render } from "./ColorPickerComponent.vue?vue&type=template&id=52cb20f2&scoped=true"
import script from "./ColorPickerComponent.vue?vue&type=script&lang=js"
export * from "./ColorPickerComponent.vue?vue&type=script&lang=js"

import "./ColorPickerComponent.vue?vue&type=style&index=0&id=52cb20f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cb20f2"]])

export default __exports__